import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FormikContextType, FormikProvider } from 'formik';
import { ScrollbarsAutoHideBehavior, ScrollbarsVisibilityBehavior } from 'overlayscrollbars';
import { WithScrollbars } from '@eposnow/ui-core';
import { UIContext } from '../../../../../context/UIContext';
import FormikNumberField from '../../../../../components/formikComponents/FormikNumberField';
import SideFormActions from '../../../../../components/createEditComponents/SideFormActions';
import FormikTextField from '../../../../../components/formikComponents/FormikTextField';
import { SidekickTablesContext } from '../../helpers/SidekickTablesContext';
import FormikSelect from '../../../../../components/formikComponents/FormikSelect';

const ImportedProductsForm = ({
  formik,
  cancelAction,
  objectId,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikContextType<any>;
  cancelAction: () => void;
  objectId: string;
}) => {
  const { t } = useTranslation();
  const { categories } = useContext(SidekickTablesContext);
  const { colorMode } = useContext(UIContext);

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit} style={{ height: 'calc(100vh - 151px)' }}>
        <WithScrollbars
          style={{
            width: '100%',
            height: '100%',
            minHeight: '100px',
            paddingRight: '8px',
            paddingTop: '8px',
          }}
          options={{
            scrollbars: {
              theme: colorMode === 'light' ? 'os-theme-dark' : 'os-theme-light',
              visibility: 'auto' as ScrollbarsVisibilityBehavior,
              autoHide: 'move' as ScrollbarsAutoHideBehavior,
              dragScroll: true,
              clickScroll: true,
            },
          }}
        >
          <FormikTextField
            label={t('screens.products.sidekick.import.productsTable.name')}
            id="name"
            required
            invalidPattern={/[#']/g}
            objectId={objectId}
            name="name"
          />
          <FormikTextField
            label={t('screens.products.sidekick.import.productsTable.description')}
            id="description"
            invalidPattern={/[#']/g}
            objectId={objectId}
            name="description"
          />
          <FormikSelect
            label={t('screens.products.sidekick.import.productsTable.category')}
            id="categoryId"
            name="categoryId"
            defaultValue={-1}
            options={categories}
            objectId={objectId}
          />
          <FormikNumberField
            label={t('screens.products.sidekick.import.productsTable.salePriceIncTax')}
            id="salePriceIncTax"
            maxValue={10000}
            minValue={0}
            decimalScale={2}
            objectId={objectId}
            name="salePriceIncTax"
          />
        </WithScrollbars>
        <SideFormActions cancelAction={cancelAction} />
      </Form>
    </FormikProvider>
  );
};
export default ImportedProductsForm;
